
import { Breadcrumbs } from "@material-ui/core";
import { pickRandomIndex } from "../util/tools"
import { CONSTS } from "../util/object"


// autonomous game targets
//    - finger down (calc hit unless init)
//    - show target  (only when fingers are down)
//    - finger up & no target (too early)
//    - finger up & has target (calc reaction time => NOT target specifi!)
class TargetClass {
    _element = null;
    _animate = null;
    _keyframes = [];
    _duration = null;
    _iteration = null;
    _randx = null;
    _randy = null;
    _x = null;
    _y = null;
    _x1 = null;
    _y1 = null;
    _reacted = false;
    _color = null;
    _scale = 1;
    _lead = false;      // if this is a leader (not an actionable target)

    get x() {
        if ((this._animate !== null) && (this._animate !== undefined)) {
            var pct = this._animate.effect.getComputedTiming().progress;
            var x = Math.floor(((this._x1 - this._x) * pct) + this._x);
            return x;
        }
        return 0;
    }

    get y() {
        if ((this._animate !== null) && (this._animate !== undefined)) {
            var pct = this._animate.effect.getComputedTiming().progress;
            var y = Math.floor(((this._y1 - this._y) * pct) + this._y);
            return y;
        }
        return 0;
    }

    get last_x() {
        return this._x1;
    }

    get last_y() {
        return this._y1;
    }

    get color() {
        return this._color;
    }

    get scale() {
        return this._scale;
    }

    get reacted() {
        return this._reacted;
    }

    get lead() {
        return this._lead;
    }

    set reacted(value) {
        this._reacted = value;
    }

    set scale(value) {
        this._scale = value;
    }


    set color(value) {
        //console.log("54:  set color=",value);
        this._color = value;
        if(this._element !== null) {
            this._element.style.background = value;
        }
    }

    // bind the HTML element to this object, manage the full life cycle
    //
    constructor(element) {
        this._element = element;
        //console.log("target.16:  NEW target binding to ", element);
    }

    // scheme = {x, y, move, duration}
    // screen = {x, y}
    create = (scheme, screen, scale) => {
        if(scheme === undefined) {
            return null;
        }
        this._scale = scale;
        this._lead = false;
        switch(scheme.type) {
            case "base":
                // home base
                this._color = 'rgba(160,62,76,0.95)';
                break;
            case "lead":
                // non-click leader to a bounce
                this._color = 'rgba(100,100,100,0.9)';
                this._color = 'rgba(255,255,0,0.9)';
                this._lead = true;
                break;
            case "mover":
                // moving target
                this._color = 'rgba(255,0,0,1)';
                break;
        }
        this._element.style.background = this._color;

        const y_bar = CONSTS.GOBACK_BAR_HEIGHT;     // top bar
        const min_x = CONSTS.GAME_SCREEN_MARGINX;   // margin at border
        const min_y = CONSTS.GAME_SCREEN_MARGINY;   // margin at border
        const x_fifth = (screen.x - (2 * min_x)) / 5;
        const x_quarter = (screen.x - (2 * min_x)) / 4;
        const x_half = (screen.x - (2 * min_x)) / 2;
        const y_quarter = (screen.y - (2 * min_y) - y_bar) / 4;
        const y_fifth = (screen.y - (2 * min_y) - y_bar) / 5;
        const y_half = (screen.y - (2 * min_y) - y_bar) / 2;
        this._randx0 = pickRandomIndex(100) / 100;
        this._randy0 = pickRandomIndex(100) / 100;
        this._randx1 = pickRandomIndex(100) / 100;
        this._randy1 = pickRandomIndex(100) / 100;
        //console.log("target.134:  . . . START CREATE  type=",scheme.type,"  scheme.x=", scheme.x, " scheme.y=",scheme.y);
        switch(scheme.x) {
            case  "left":
                this._x = (this._randx0 * x_fifth) + (x_fifth * 0) + min_x;
                break;
            case  "40%":
                this._x = (this._randx0 * x_fifth) + (x_fifth * 1) + min_x;
                break;
            case  "60%":
                this._x = (this._randx0 * x_fifth) + (x_fifth * 2) + min_x;
                break;
            case  "80%":
                this._x = (this._randx0 * x_fifth) + (x_fifth * 3) + min_x;
                break;
            case  "right":
                this._x = (this._randx0 * x_fifth) + (x_fifth * 4) + min_x;
                break;
            case  "r50":
                this._x = (this._randx0 * x_half) + x_half + min_x;
            case  "m50":
                this._x = (this._randx0 * x_half) + x_quarter + min_x;
                break;
            case  "l50":
                this._x = (this._randx0 * x_half) + min_x;
                break;
            case  "random":  // anywhere
                this._x = (this._randx0 * (x_fifth * 5)) + min_x;
                break;
            case  "x":  // current location
                this._x = this._x;      // NEED TO READ FROM ANIMATION?
                break;
            default: 
                this._x = scheme.x;
                //console.log("target.79:  UNKNONWN scheme.x ", scheme.x);
                break;
        }
        console.log("target.170:          randy", this._randy0, "  y_fifth=",y_fifth, "  min_y=",min_y, " y_bar=",y_bar)
        switch(scheme.y) {
            case  "top":
                this._y = (this._randy0 * y_fifth) + (y_fifth * 0) + min_y + y_bar;
                break;
            case  "40%":
                this._y = (this._randy0 * y_fifth) + (y_fifth * 1) + min_y + y_bar;
                break;
            case  "60%":
                this._y = (this._randy0 * y_fifth) + (y_fifth * 2) + min_y + y_bar;
                break;
            case  "80%":
                this._y = (this._randy0 * y_fifth) + (y_fifth * 3) + min_y + y_bar;
                break;
            case  "t80":  // top 80%
                this._y = (this._randy0 * (y_fifth * 4)) + min_y + y_bar;
                break;
            case  "t50":  // top 50%
                this._y = (this._randy0 * (y_half)) + min_y + y_bar;
                break;
            case  "m50":  // top 50%
                this._y = (this._randy0 * (y_half)) + y_quarter + min_y + y_bar;
                break;
            case  "b50":  // bottom 50%
                this._y = (this._randy0 * y_half) + y_half + min_y + y_bar;
                break;
            case  "b80":  // top 80%
                this._y = (this._randy0 * (y_fifth * 4)) + (y_fifth * 1) + min_y + y_bar;
                break;
            case  "bottom":
                this._y = (this._randy0 * y_fifth) + (y_fifth * 4) + min_y + y_bar;
                break;
            case  "random":  // anywhere
                this._y = (this._randy0 * (y_fifth * 5)) + min_y + y_bar;
                break;
            case  "y":  // current location
                this._y = this._y;      // NEED TO READ FROM ANIMATION?
                break;
            default: 
                this._y = scheme.y;
                //console.log("target.147:  UNKNONWN scheme.y=", this._y);
                break;
        }
        this._x = Math.floor(this._x);
        this._y = Math.floor(this._y);
        //this._x = Math.floor(this._x) * scale;
        //this._y = Math.floor(this._y) * scale;
        var frame0 = {};
        frame0.left = this._x+"px";
        frame0.top = this._y+"px";
        this._keyframes.push(frame0);
        console.log("target.156:        CREATE FRAME0  ",this._color, "  ", scheme.x," x=",this._x, "    ",scheme.y,"   y=",this._y);



        // use formula to return x, y from degree
        //
        //[_xx, _yy] = calcXY(this.x, this.y, cheme.move);  // degrees
        function calcXY(x, y, degree) {
            var xx, yy;
            var deg = parseInt(degree);
            if (degree == "random") {
            }

            xx = x;
            yy = y;

            if ((deg > 0) && (deg < 90)) {
                xx = 12312;  // upper right
            } else if ((deg > 90) && (deg < 180)) {
            } else if ((deg > 180) && (deg < 270)) {
            } else if ((deg > 270) && (deg < 360)) {
            }

            return [ xx, yy ];
        }

        var _xx, _yy;
        this._iteration = 1;
        switch(scheme.move) {
            case  "static":
                _xx = this._x;
                _yy = this._y;
                this._iteration = 1;
                break;
            case "270":
            case  "left":
                _xx = 0;
                _yy = this._y;
                break;
            case "90":
            case  "right":
                _xx = screen.x;
                _yy = this._y;
                break;
            case "0":
            case  "up":
                _xx = this._x;
                _yy = 0;
                break;
            case "180":
            case  "down":
                //_yy = screen.y;
                _xx = this._x;
                _yy = screen.y;
                break;
            case  "30":
                [_xx, _yy] = calcXY(this.x, this.y, 30);
                break;
            case  "random":
                _xx = (this._randx1 * (y_fifth * 5)) + min_y;
                _yy = (this._randy1 * (y_fifth * 5)) + min_y;
                break;
        }

        this._x1 = _xx;
        this._y1 = _yy;

        var frame1 = {};
        frame1.left = Math.floor(this._x1)+"px";
        frame1.top = Math.floor(this._y1)+"px";
        this._keyframes.push(frame1);

        var duration = (typeof(scheme.duration) == "string") ? scheme.duration.toLowerCase() : parseInt(scheme.duration);
        if ((duration > 0) || (duration == "auto") || (duration == "infinity")) {
            //console.log("target.269:          duration=", JSON.stringify(scheme));
            this._duration = scheme.duration;
        } else {
            console.log("target.271:    ERROR: Invalid  duration=", JSON.stringify(scheme));
            return null;
        }
        //console.log("target.136:          CREATE ", JSON.stringify(this._keyframes), "  scheme=", scheme, "  screen=", JSON.stringify(screen));

        //const _target = document.createElement("div");
        //const _parent = document.getElementById(parent);
        //document.body.insertBefore(_target, _parent);
        return true;
    }



    // api: https://developer.mozilla.org/en-US/docs/Web/API/Element/animate
    start = () => {
        //if(this._duration)
        //console.log("target.305:  start animation   duration=", this._duration);
        if ((this._element !== null) && (this._duration !== undefined) && (this._duration !== null)) {
            //console.log("target.59:  ....start animation ", JSON.stringify(this._keyframes));
            this._element.style.display = "block";
            var animate = this._element.animate(
                  this._keyframes, 
                  {   duration: this._duration,
                      iterations: this._iteration
                      //iterations: Infinity
                  });
            //animate.onfinish = this._callback;
            this._animate = animate
            return animate;
        }
    }


    stop = () => {
        if ((this._element !== null) && (this._animate !== null)) {
            this._animate.pause();
            //console.log("target.73:  stop animation ", JSON.stringify(this._animate));
            this._animate.cancel();
        } else {
            console.log("target.259:  CAN NOT STOP NULL animation");
        }
    }


    hit = (x0, y0, xx, yy) => {
        var pct = this._animate.effect.getComputedTiming().progress;
        var x1 = Math.floor(((this._x1 - this._x) * pct) + this._x);
        var y1 = Math.floor(((this._y1 - this._y) * pct) + this._y);
        var delta_x = Math.floor(Math.abs(x0 - x1));
        var delta_y = Math.floor(Math.abs(y0 - y1));
        pct = (pct) ? pct.toFixed(2) : 0;
        console.log("hit.210:           got a click  progress=", pct, "   x0=", x0, "  x1=",x1, " y0=",y0, " y1=",y1, " xx=",xx, " yy=",yy," dx=",delta_x, " dy=",delta_y);
        var threshold = CONSTS.GAME_TARGET_SIZE * CONSTS.GAME_SLOW_TARGET_MULTIPLIER;

        //if ((delta_x < (xx * CONSTS.GAME_TARGET_MULTIPLIER)) && (delta_y < (yy * CONSTS.GAME_TARGET_MULTIPLIER))) {
        if ((delta_x < threshold) && (delta_y < threshold)) {
            console.log("hit.276:       ++++  HIT TARGET!    xx=",xx, " yy=",yy," dx=",delta_x, " dy=",delta_y, " thresh=",threshold);
            return true;    // got a hit
        } else {
            console.log("hit.279:       ----  MISS!    xx=",xx, " yy=",yy," dx=",delta_x, " dy=",delta_y, " thresh=",threshold);
            return false;   // got a miss
        }
    }


    destroy = () => {
        if ((this._element !== null) && (this._animate !== null)) {
            this._animate.cancel();
            //console.log("target.73:  animation cancelled and hidden");
            this._element.style.display = "none";
        }
    }


    hide = () => {
        if(this._element !== null) {
            this._element.style.display = "none";
        }
    }


    // return (x,y) at this time
    get position() {
        //var pct = piece.effect.getComputedTiming().progress;
        //var x = 300 * pct;    // extrapolate the position, calc with vector!

    }



    show = () => {
    }


}


/* src: https://codepen.io/clarkdong/pen/dyNBazB?editors=1111

const pieceKeyframes0 = [
  { left: "50%", top: 0 },
  { left: "calc(100% - 12px)", top: "50%" },
  { left: "50%", top: "calc(100% - 12px)" },
  { left: 0, top: "50%" },
  { left: "calc(100% - 12px)", top: "50%" },
  { left: "50%", top:  0},
];

const pieceKeyframes = [
  { left: 0, top: "50%" },
  { left: '300px', top: "50%" },
]


const el = document.querySelector(".piece");
const el1 = document.querySelector(".mark");

const pieceAnimate = el.animate(
  pieceKeyframes, 
  {   duration: 1000,
      iterations: Infinity
  });

const containerAnimate = document
  .querySelector(".container")
  .animate(
    [{ borderColor: "orange" }, { borderColor: "white" }], 
    {   duration: pieceAnimate.effect.getComputedTiming().duration / 2,
        iterations: Infinity
    });

function handleClick() {
  //console.log("got a click  ", pieceAnimate.effect.getComputedTiming().progress);
  var pct = pieceAnimate.effect.getComputedTiming().progress;
  var x = 300 * pct;
  console.log("got a click: x=", x);
  el1.style.left = x+"px";
}
 window.addEventListener('click', handleClick, false);


body {
  background-color: #222;
}
.container {
  position: relative;
  width: 300px;
  height: 300px;
  border: 1px solid #fff;
  margin: 0 auto;
}
.piece {
  position: absolute;
  background-color: white;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  top: 123px;
}

.mark {
  position: absolute;
  background-color: red;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  top: 123px;
}



  <div id="box" class="container">
    <div class="piece" />
   
  </div>
 <div class="mark" />

*/

export { TargetClass }